<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs />
        <div class="table-agile-info" style="position:relative">
          <div v-if="!isTrainigSite" style="top:30px;right:20px;position:absolute;z-index:10;" >
            <el-button v-if="!isOldService" type="success" icon="el-icon-circle-plus" @click="createProduct">新建产品</el-button>
          </div>
          <el-tabs v-model="searchData.srv_category" @tab-click="changeTab">
            <el-tab-pane v-if="!isTrainigSite || $hasPermission(1)" name="SRV_SERVICE_OLD" label="旧版产品(废弃)" />
            <el-tab-pane v-if="!isTrainigSite || $hasPermission(1)" name="SRV_JIEMO" label="芥末日语" />
            <el-tab-pane v-if="!isTrainigSite || $hasPermission(1)" name="SRV_QCRB" label="前程日本" />
            <el-tab-pane v-if="isTrainigSite || $hasPermission(1)" name="SRV_TRAINING" label="芥末外语" />

            <div class="searchList">
              <div class="box-content">
                <label class="form-tit">产品ID：</label>
                <el-input v-model="searchData.srv_id" class="jm-input220" type="text" clearable />
              </div>
              <div class="box-content">
                <label class="form-tit">产品编号：</label>
                <el-input v-model="searchData.srv_code" class="jm-input220" type="text" clearable />
              </div>
              <div class="box-content">
                <label class="form-tit">产品名称：</label>
                <el-input v-model="searchData.srv_name" class="jm-input220" type="text" clearable />
              </div>
              <div class="box-content">
                <label class="form-tit">一级类目：</label>
                <el-select
                  class="jm-input220"
                  v-model="searchData.srv_mainclass"
                  placeholder="请选择"
                  clearable>
                  <el-option
                    v-for="item in ds.srv_mainclass"
                    :key="item.id"
                    :label="item.value"
                    :value="item.id"/>
                </el-select>
              </div>
              <div class="box-content">
                <label class="form-tit">二级类目：</label>
                <el-select
                  v-if="isTraining"
                  v-model="searchData.srv_collection"
                  class="jm-input220"
                  placeholder="请选择" clearable>
                  <el-option
                    v-for="item in ds.srv_collection"
                    :key="item.key"
                    :label="item.name"
                    :value="item.key"/>
                </el-select>
                <el-select
                  v-else
                  v-model="searchData.srv_country"
                  class="jm-input220"
                  placeholder="请选择" clearable>
                  <el-option
                    v-for="item in ds.srv_country"
                    :key="item.key"
                    :label="item.name"
                    :value="item.key"/>
                </el-select>
              </div>
              <div class="box-content">
                <label class="form-tit">三级类目：</label>
                <el-input v-model="searchData.srv_group" class="jm-input220" type="text" clearable />
              </div>
              <div class="box-content">
                <label class="form-tit">是否启用：</label>
                <el-switch
                  active-text="禁用"
                  inactive-text="启用"
                  :active-value="1"
                  :inactive-value="0"
                  v-model="searchData.is_del" />
              </div>
            </div>
            <div class="searchBottom">
              <el-button @click="refreshSearch" type="primary" icon="el-icon-search">
                查 询
              </el-button>
              <el-button @click="createProduct" v-if="isTrainigSite" type="success" icon="el-icon-circle-plus">
                新建产品
              </el-button>
            </div>

            <el-alert v-if="isOldService" type="error" :closable="false">
              “旧版产品(已废弃)”无法更改，仅供查看历史记录。
            </el-alert>
            <el-alert v-else-if="!!searchData.is_del" type="warning" :closable="false">
              已被禁用的产品无法更改，如要重新启用请联系系统管理员。
            </el-alert>

            <!--结果列表-->
            <jm-tableList
              class="process-botton"
              url="/index/product_center/getList"
              :search-data="searchData"
              :refresh.sync="refresh"
            >
              <el-table-column
                slot="is_del"
                slot-scope="scope"
                v-bind="scope.attrs"
                :label="scope.label"
              >
                <template slot-scope="props">
                  <el-tag v-if="props.row.is_del" type="danger">禁用</el-tag>
                  <el-tag v-else type="success">启用</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                slot="lastColumn"
                label="操作"
                width="250">
                <template slot-scope="scope">
                  <el-button
                    v-if="isOldService || scope.row.is_del"
                    size="mini"
                    type="primary" icon="el-icon-search" @click="editProduct(scope.row)">
                    查看
                  </el-button>
                  <el-button
                    v-else
                    size="mini"
                    type="primary" icon="el-icon-edit" @click="editProduct(scope.row)">
                    编辑
                  </el-button>
                  <el-button
                    v-if="!isOldService && !scope.row.is_del"
                    size="mini"
                    type="danger" icon="el-icon-delete" @click="disableProduct(scope.row)">禁用
                  </el-button>
                </template>
              </el-table-column>
            </jm-tableList>
          </el-tabs>
        </div>
      </div>
    </div>
    <!-- 产品详情窗体 -->
    <product-form
      ref="productDialog"
      :form-ds="ds"
      :form-data="productData"
      :after-saving="refreshSearch">
    </product-form>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs';
import tableList from '@/components/data/tableList.vue';
import { jmDictSelect } from '@/components/tool';
import ProductForm from './components/productForm';

export default {
  data() {
    return {
      searchData: {
        srv_category: 'SRV_JIEMO',
        srv_code: '',
        srv_name: '',
        add_time: '',
        srv_mainclass: '',
        srv_country: '',
        srv_collection: '',
        srv_group: '',
        is_del: 0,
      },
      searchDs: {},
      ds: {},
      refresh: false,
      productData: {},
    };
  },
  mounted() {
    this.searchData.srv_category = this.isTrainigSite ? 'SRV_TRAINING' : 'SRV_JIEMO';
    this.initSearchDs();
  },
  methods: {
    changeTab() {
      this.initSearchDs();
      this.refresh = true;

      this.searchData.srv_code = '';
      this.searchData.srv_name = '';
      this.searchData.add_time = '';
      this.searchData.srv_mainclass = '';
      this.searchData.srv_country = '';
      this.searchData.srv_collection = '';
      this.searchData.srv_group = '';
      this.searchData.is_del = 0;
    },
    // 获取字典数据
    initSearchDs() {
      let category = this.searchData.srv_category;
      if (this.searchDs[category]) {
        this.ds = this.searchDs[category];
      } else {
        this.$http._post({
          url: '/index/product_center/searchDs',
          data: { category: category }
        }).then((data) => {
          this.searchDs[category] = data.data;
          this.ds = data.data;
        });
      }
    },
    // 编辑
    editProduct(data) {
      this.$refs.productDialog.showDialog();

      // 重构 srv_price 数组
      let srvPrice = [];
      if (data.srv_price) {
        Object.entries(data.srv_price).forEach(([label, value]) => {
          srvPrice.push({
            label: label,
            value: value,
          });
        });
      }
      this.productData = Object.assign({}, data, { srv_price: srvPrice });
    },
    // 创建
    createProduct() {
      this.$refs.productDialog.showDialog();
      this.productData = {
        srv_id: 0,
        srv_category: this.searchData.srv_category,
        srv_mainclass: '',
        srv_country: '',
        srv_collection: '',
        srv_group: '',
        srv_class: [],
        srv_price: [],
      };
    },
    // 禁用
    disableProduct(data) {
      let srvId = data.srv_id;
      this.$confirm('此操作将永久禁用该产品, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 禁用操纵
        this.$http._post({
          url: '/index/product_center/del',
          data: { srv_id: srvId }
        }).then(() => {
          this.refresh = true;
        });
        this.$message({
          type: 'success',
          message: '禁用成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消禁用'
        });
      });
    },
    refreshSearch() {
      this.refresh = true;
    }
  },
  computed: {
    isOldService() {
      return this.searchData.srv_category === 'SRV_SERVICE_OLD';
    },
    isTraining() {
      return this.searchData.srv_category === 'SRV_TRAINING';
    },
    isTrainigSite() {
      return this.$siteName === 'training';
    }
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-tableList': tableList,
    jmDictSelect,
    ProductForm
  }
};
</script>
<style scoped>
  .form-tit {
    margin-left: 10px;
  }
</style>

